import React from "react"

export default class UserPointsInline extends React.Component {

	constructor(props) {
		super(props);

		this.onClick = this.onClick.bind(this);
	}

	render() {
		return (
			<div className="user-points-inline-wrapper" onClick={this.onClick}>
				<div className="user-points-inline">
					<div className="points">
						<span className="user-points">{this.props.user_total_points}</span>
						<span className="total-points">PTS / {this.props.user_current_points_level.number_of_points_range_end}</span>
					</div>
					<div className="level">
						<span className="level-label">LEVEL</span>
						<span className="level-number">{this.props.user_current_points_level_name}</span>
						<span className="level-image"><img src={this.props.image_src} /></span>
					</div>
				</div>
			</div>
		);
	}

	onClick(e) {
		e.preventDefault();
		e.stopPropagation();
		window.location.href = this.props.learn_more_path;
	}

}